module.exports = __webpack_public_path__ + "img/shrewd-save-7.89cca799.jpg";